import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { Image } from '../../components/Image/Image'
import { Button } from '../../components/Button/Button'
import { selectLang } from '../../store/langSlice'
import { goNextScreen } from '../../store/screenSlice'

import styles from './SelectLang.module.scss'
import bgImg from './bg.jpg'
import ttImg from './tt.png'
import ruImg from './ru.png'


/* eslint react/prop-types: ["off"] */
function SelectLangBody({ isVisible, selectLang, goNextScreen }) {
    return (
        <div className={classNames(styles.wrapper, { [styles.visible]: isVisible })}>
            <Image src={bgImg} className={styles.bg} />

            <Button
                muted
                src={ttImg}
                className={styles.ttBtn}
                onClick={() => {
                    selectLang('tt')
                    goNextScreen()
                }}
            />
            <Button
                muted
                src={ruImg}
                className={styles.ruBtn}
                onClick={() => {
                    selectLang('ru')
                    goNextScreen()
                }}
            />
        </div>
    )
}

export const SelectLang = connect(null, {
    selectLang,
    goNextScreen,
})(SelectLangBody)
